
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class Panel extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    small: PropTypes.bool,
    error: PropTypes.bool,
    notice: PropTypes.bool,
    custom: PropTypes.bool
  }

  static defaultProps = {}

  render() {
    const {className, small, error, notice, custom} = this.props
    const classNames = classnames('panel', className, {
      'is-small': small,
      'is-error': error,
      'is-notice': notice,
      'is-custom': custom
    })

    return (
      <div className={classNames}>
        {this.renderTitle()}
        {this.renderBody()}
      </div>
    )
  }

  renderTitle() {
    const {title} = this.props

    if (!title) return null

    return (
      <div className='panel_title'>{title}</div>
    )
  }

  renderBody() {
    return (
      <div className='panel_body'>{this.props.children}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Panel/index.js